import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let items = state.get('items') || Map();
    return state.set('items', Map()).set('state', 'IN_PROGRESS');
}

export function error(state, action) {
    let items = state.get('items') || Map();

    state = state.set('state', 'ERROR')
                .set('errors', fromJS(action.errors));

    return state.set('items', items);
}

export function finish(state, action) {
    let { audits } = action,
        items = state.get('items');

    audits.forEach(audit => {
        items = items.set(audit.id, fromJS(audit));
    });

    return state.set('items', items).set('state', 'FINISHED');
}
